import React from 'react';
import PropTypes from 'prop-types';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router';

import { withConfig, withI18n } from 'spa/Components/Context';
import { cn } from 'spa/css';
import autobind from 'autobind-decorator';

import Button, {
  ButtonSizeTypes,
  ButtonType,
} from '@urbanmassage/component-library/lib/Button/Button';

import AddressField2021 from 'spa/Components/AddressField2021';
import Tooltip from 'spa/Components/Tooltip';

import './address-picker-simple-row.less';

const MOBILE_BREAKPOINT_WIDTH = 600;

@withRouter
@inject(({
  store: {
    address,
    notifications,
    screen,
    tracker,
  },
  selection,
}) =>
  ({
    address,
    notifications,
    screen,
    tracker,
    selection,
  }))
@observer
@withI18n
@withConfig
class AddressPickerSimpleRow extends React.Component {
  static propTypes = {
    address: PropTypes.shape({
      error: PropTypes.object,
      isLoading: PropTypes.bool.isRequired,
      load: PropTypes.func.isRequired,
      reset: PropTypes.func,
      response: PropTypes.object,
      search: PropTypes.object,
    }).isRequired,
    customButtonTextDesktop: PropTypes.string,
    customButtonTextMobile: PropTypes.string,
    isLoading: PropTypes.bool,
    onClickSelectAddress: PropTypes.func,
    roundInputBox: PropTypes.bool,
    screen: PropTypes.object.isRequired,
    stackButton: PropTypes.bool,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @observable selectedAddress;
  @observable showToolTip = false;

  @autobind
  @action('onSelectAddress - AddressPickerSimpleRow')
  onSelectAddress(value) {
    this.selectedAddress = value;
  }

  @autobind
  @action('onClickUseAddress - AddressPickerSimpleRow')
  onClickUseAddress() {
    const {
      onClickSelectAddress,
    } = this.props;

    this.showToolTip = false;

    if (!this.selectedAddress) {
      this.showToolTip = true;

      return;
    }

    if (onClickSelectAddress) onClickSelectAddress(this.selectedAddress);
  }

  @autobind
  @action('onClickClearAddress - AddressPickerSimpleRow')
  onClickClearAddress(event) {
    if (event) event.preventDefault();

    const {
      address,
      tracker,
      trackingCategory,
      trackingLocation,
    } = this.props;

    this.selectedAddress = null;
    this.showToolTip = false;

    address.reset();

    const trackingData = {
      category: trackingCategory,
    };

    if (trackingLocation) {
      trackingData.data = {
        page: trackingLocation,
      };
    }

    tracker.track('Clicked Clear Location', trackingData);
  }

  @autobind
  @action('onCloseToolTip - AddressPickerSimpleRow')
  onCloseToolTip(event) {
    event.preventDefault();
    this.showToolTip = false;
  }

  @autobind addressFieldRef(addressField) { this.addressField = addressField; }

  render() {
    const { i18n } = this.context;
    const {
      customButtonTextDesktop,
      customButtonTextMobile,
      isLoading: isLoadingCallback,
      roundInputBox,
      screen,
      stackButton,
      trackingCategory,
    } = this.props;
    const { isLoading, search } = this.props.address;

    return (
      <div className="address-picker-simple-row" data-testid="address-picker-simple-row-container">
        <div className="address-picker-simple-row__search-container">
          <div
            className={cn(
              'row address-picker-simple-row__search-field-container',
              roundInputBox && 'address-picker-simple-row__search-field-container--round',
              stackButton && 'address-picker-simple-row__search-field-container--stacked',
            )}
            data-testid="address-picker-simple-row-field-container"
          >
            <div
              className={cn(
                'address-picker-simple-row__search-field-input-wrapper',
                stackButton && 'address-picker-simple-row__search-field-input-wrapper--stacked',
              )}
              data-testid="address-picker-simple-row-field-wrapper"
            >
              <AddressField2021
                data-qa="address-picker-simple-row-field"
                className="address-picker-simple-row__search-field"
                clearStyles={{
                  display: 'block',
                  position: 'absolute',
                  top: '30%',
                  right: '1.5rem',
                  height: '2.5rem',
                  width: '2.5rem',
                }}
                defaultValue={search && search.term}
                disabled={isLoading}
                hideClearOnEmpty
                includeClear
                onClear={this.onClickClearAddress}
                onSelect={this.onSelectAddress}
                placeholder={i18n._x('Enter your postcode', 'Home address picker')}
                ref={this.addressFieldRef}
                skipGeolocation
                // skipInitialLoad={this.isInitialLoad}
                trackingCategory={trackingCategory}
              />
              {this.showToolTip &&
                <Tooltip
                  align={screen.width > MOBILE_BREAKPOINT_WIDTH ? 'center' : 'top'}
                  containerClassName="address-picker-simple-row__tooltip"
                  hide={!this.showToolTip}
                  onClose={this.onCloseToolTip}
                  theme="light"
                  width={screen.width > MOBILE_BREAKPOINT_WIDTH ? 400 : null}
                >
                  <span>
                    {i18n._x('Please enter your address', 'Find appointment box')}
                  </span>
                </Tooltip>
              }
            </div>
            <div
              className={cn(
                'address-picker-simple-row__search-button-container',
                stackButton && 'address-picker-simple-row__search-button-container--stacked',
              )}
              data-testid="address-picker-simple-row-search-button-container"
            >
              <Button
                block
                className="address-picker-simple-row__search-button"
                data-qa="address-picker-simple-row-button"
                data-testid="address-picker-simple-row-button"
                isLoading={isLoadingCallback}
                onClick={this.onClickUseAddress}
                size={ButtonSizeTypes.default}
                type={ButtonType.button}
              >
                <span className="address-picker-simple-row__search-button-text--mobile">
                  {customButtonTextMobile || i18n._x('Book now', 'homepage top section find appointments')}
                </span>
                <span className="address-picker-simple-row__search-button-text--desktop">
                  {customButtonTextDesktop || i18n._x('Book now', 'homepage top section find appointments')}
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddressPickerSimpleRow;



// WEBPACK FOOTER //
// ./spa/Components/AddressPicker/AddressPickerSimpleRow.jsx